export default {"src":"/_next/static/media/cards-icon-10.21a54733.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};